module.exports = __webpack_public_path__ + "img/scholar5.5080a000.png";